import { trackEvent } from '../3rdParty/tracking';

type TrackListingPhotoClickParams = {
  index: number;
  /**
   * imageLocation is used to differentiate between clicks on hero images, gallery images,
   * and review images in our analytics.
   * This allows us to analyze user behavior more effectively and make informed decisions
   * about UI/UX improvements.
  */
  imageLocation: 'hero' | 'gallery' | 'review';
  listingId: string;
  totalPhotos: number;
};

const trackListingPhotoClick = ({
  index,
  imageLocation,
  listingId,
  totalPhotos,
}: TrackListingPhotoClickParams): void => {
  trackEvent(`listing_${imageLocation}_image_click`, {
    p1: listingId,
    p2: index + 1, // 1-indexed image position within the listing photos for easier analysis in GA
    p3: totalPhotos, // total number of photos for the listing
  });
};

export default trackListingPhotoClick;
